import { render } from "./HeroApprovalLeaveModal.vue?vue&type=template&id=37d7b059&scoped=true"
import script from "./HeroApprovalLeaveModal.vue?vue&type=script&lang=js"
export * from "./HeroApprovalLeaveModal.vue?vue&type=script&lang=js"

import "./HeroApprovalLeaveModal.vue?vue&type=style&index=0&id=37d7b059&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d7b059"]])

export default __exports__